module.exports = __webpack_public_path__ + "img/viewAll-resume-icon.390ca48e.svg";